import { Grid } from '@material-ui/core';
import { useParams } from 'react-router-dom';
import styles from './Common.module.scss';
import useViewRealPlayQuery from 'features/realplays/services/queries/useViewRealplay';
import SubmitRealPlayHeader from './SubmitRealPlayHeader';
import SubmitRealplayBody from './SubmitRealplayBody';
import RealPlayRecordDataHelper from 'features/realplays/RealPlayRecordData.helper';

const SubmitRealplay = () => {
  const { uuid } = useParams();

  const { data, isLoading: isRoleplayViewLoading } = useViewRealPlayQuery({
    uuid,
  });
  const { scenarios } = RealPlayRecordDataHelper();

  if (isRoleplayViewLoading || !scenarios?.length > 0) return null;

  return (
    <Grid container direction="row" spacing={2} style={{ padding: '1rem 0 0 1rem', width: '100%' }}>
      <Grid item xs={12} md={8} lg={6} style={{ margin: '0 auto' }}>
        <div className={styles.background}>
          <SubmitRealPlayHeader data={data} />
          <SubmitRealplayBody />
        </div>
      </Grid>
    </Grid>
  );
};

export default SubmitRealplay;
